import {IInfiniteListQuery} from "@pg-design/infinite-list";

import {getRequestStateFromRtkQuery} from "../../store/utils/get_request_state_from_rtk_query";
import {getActiveVendorOffers} from "../../vendor/utils/get_active_vendor_offers";
import {useGetVendorOfferListQuery} from "../api/get_vendor_offer_list";
import {IVendorOffer} from "../types/VendorOffer";

export function useVendorOffers(skipFetch = false, vendorId: number): IInfiniteListQuery<IVendorOffer> {
    const {data, isFetching, isLoading, isSuccess, isError, isUninitialized} = useGetVendorOfferListQuery({vendor: vendorId}, {skip: skipFetch});

    const activeOffers = getActiveVendorOffers(data ? data.results : []);

    return {
        isInitialized: !isUninitialized,
        isSuccess,
        isLoading: isLoading || isFetching,
        isError,
        data: data ? activeOffers : [],
        count: data ? activeOffers.length : 0,
        page: data ? data.page : 1,
        pageSize: data ? data.page_size : 1000,
        requestState: getRequestStateFromRtkQuery({isFetching, isLoading, isSuccess, isError})
    };
}
import {IInfiniteListQuery} from "@pg-design/infinite-list";

import {getRequestStateFromRtkQuery} from "../../store/utils/get_request_state_from_rtk_query";
import {getActiveVendorOffers} from "../../vendor/utils/get_active_vendor_offers";
import {useGetVendorOfferListQuery} from "../api/get_vendor_offer_list";
import {IVendorOffer} from "../types/VendorOffer";

export function useVendorOffers(skipFetch = false, vendorId: number): IInfiniteListQuery<IVendorOffer> {
    const {data, isFetching, isLoading, isSuccess, isError, isUninitialized} = useGetVendorOfferListQuery({vendor: vendorId}, {skip: skipFetch});

    const activeOffers = getActiveVendorOffers(data ? data.results : []);

    return {
        isInitialized: !isUninitialized,
        isSuccess,
        isLoading: isLoading || isFetching,
        isError,
        data: data ? activeOffers : [],
        count: data ? activeOffers.length : 0,
        page: data ? data.page : 1,
        pageSize: data ? data.page_size : 1000,
        requestState: getRequestStateFromRtkQuery({isFetching, isLoading, isSuccess, isError})
    };
}
